import exports from "./exports";

export const EXPORTS_NAMESPACE = "exports";

export default exports;
